import { storage, database } from "firebase/app";

import recordTemplate from "./recordTemplate";
import { IUser } from "../types/auth/IUser";

const PATH = "files";

export const importFile = (user: IUser, folderId: string, file: File) => {
  const id = database().ref().child("books").push().key;
  const { uid: addedBy } = user;

  if (!id) throw Error("ID not been created.");

  const record = {
    ...recordTemplate,
    title: file.name,
    bookType: "FILE",
    addedBy,
  };

  const updates = {
    [`/books/${id}`]: { ...record, text: "", },
    [`/folders/${folderId}/books/${id}`]: record,
  };

  const metadata = {
    customMetadata: {
      folderId,
    },
  };

  const promises = [
    database().ref().update(updates),
    storage().ref(`${PATH}/${id}`).put(file, metadata),
  ];

  return Promise.all(promises).then(() => id);
};
